import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import CategoryPage from './pages/CategoryPage';
import SchemeDetail from './pages/SchemeDetail';
import SearchResults from './pages/SearchResults';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Footer from './components/Footer';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import AdminSignup from './pages/AdminSignup';
import ForgotPassword from './pages/ForgotPassword';
import AllSchemes from "./pages/AllSchemes";
import AllFeedbacks from "./pages/AllFeedbacks";
import ManageSlider from './pages/ManageSlider';
import ProtectedAdminRoute from "./components/ProtectedRoute";
import MainCategoryPage from "./pages/MainCategoryPage";
import LatestUpdatesPage from "./pages/LatestUpdatesPage";
import MostlyUsedAdmin from "./pages/MostlyUsedAdmin";
import ManageAbout from "./pages/ManageAbout";
import StateWiseSchemes from "./pages/StateWiseSchemes";
import ChatWidget from "./components/ChatWidget";
import EditScheme from "./pages/EditScheme";
import EditCategory from "./pages/EditCategory";
import EditSubcategory from "./pages/EditSubcategory";
import ScrollToTop from "./components/ScrollToTop";
import StateWiseSubcategory from './pages/StateWiseSubcategory';
import AdminLatestManager from './pages/AdminLatestManager';
import AppLoader from "./components/AppLoader";
import Disclaimer from "./pages/Disclaimer";
import API from "./api/api";

import "./fonts.css";


import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";

function App() {
  const [serverReady, setServerReady] = useState(false);

  useEffect(() => {
    let attempts = 0;

    const checkServer = async () => {
      try {
        await API.get("/health");
        console.log("✅ Backend connected");
        setServerReady(true);
      } catch (err) {
        attempts++;
        console.log("❌ Backend not ready… retry", attempts);

        if (attempts <= 5) {
          setTimeout(checkServer, 1500);
        } else {
          console.warn("⚠️ Backend unavailable, loading UI anyway...");
          setServerReady(true); // DO NOT BLOCK UI
        }
      }
    };

    checkServer();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />

      <Navbar />

      {/* ✅ Loader is INSIDE Router now */}
      {!serverReady ? (
        <div style={{ minHeight: "80vh", padding: "40px", textAlign: "center" }}>
          <h3>Loading services...</h3>
          <p>Connecting to server, please wait...</p>
          <AppLoader />
        </div>
      ) : (
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/category/:category" element={<CategoryPage />} />
            <Route path="/scheme/:id" element={<SchemeDetail />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about" element={<About />} />
            <Route path="/main/:mainCategory" element={<MainCategoryPage />} />
            <Route path="/latest-updates" element={<LatestUpdatesPage />} />
            <Route path="/state/:stateName" element={<StateWiseSchemes />} />
            <Route path="/state-category/:category/:stateName" element={<StateWiseSubcategory />} />
            <Route path="/disclaimer" element={<Disclaimer />} />

            {/* ADMIN ROUTES */}
            <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route 
              path="/admin/signup"
              element={
                <ProtectedAdminRoute allowedRoles={["superadmin"]}>
                  <AdminSignup />
                </ProtectedAdminRoute>
              }
            />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/schemes" element={<ProtectedAdminRoute><AllSchemes /></ProtectedAdminRoute>} />
            <Route path="/admin/feedbacks" element={<ProtectedAdminRoute><AllFeedbacks /></ProtectedAdminRoute>} />
            <Route path="/admin/manage-slider" element={<ProtectedAdminRoute><ManageSlider /></ProtectedAdminRoute>} />
            <Route path="/edit-scheme/:id" element={<ProtectedAdminRoute><EditScheme /></ProtectedAdminRoute>} />
            <Route path="/edit-category/:schemeId/:categoryName" element={<ProtectedAdminRoute><EditCategory /></ProtectedAdminRoute>} />
            <Route path="/admin/latest-manager" element={<ProtectedAdminRoute><AdminLatestManager /></ProtectedAdminRoute>} />
            <Route path="/edit-subcategory/:schemeId/:categoryName/:subName" element={<ProtectedAdminRoute><EditSubcategory /></ProtectedAdminRoute>} />
            <Route path="/admin/mostly-used" element={<ProtectedAdminRoute><MostlyUsedAdmin /></ProtectedAdminRoute>} />
            <Route path="/admin/manage-about" element={<ProtectedAdminRoute><ManageAbout /></ProtectedAdminRoute>} />

            <Route 
              path="*" 
              element={
                <h2 style={{ textAlign: "center", marginTop: "50px", marginBottom: "100px" }}>
                  Comming Soon...
                </h2>
              } 
            />
          </Routes>
        </div>
      )}

      <ChatWidget />
      <Footer />
    </BrowserRouter>
  );
}

export default App;
